






































































import { defineComponent, computed } from '@vue/composition-api';
import VueFileToolbarMenu from 'vue-file-toolbar-menu';
import colors from 'vuetify/lib/util/colors';

import store from '@/store';
import { loggedIn, logout } from '@/utils/auth';
import { filemenu, components } from '@/filemenu';
import { changePasswordMenu, userMenu, mustChangePassword } from './state';
import ChangePasswordMenu from './ChangePasswordMenu.vue';
import { useCurrentServer, useClient } from '@/use';
import { snackbar } from '../GlobalSnackbar';

const filemenuStyleDark = {
  '--bar-menu-bkg': colors.grey.darken4,
  '--bar-font-color': 'white',
  '--bar-menu-color': 'white',
  '--bar-button-hover-bkg': colors.grey.darken3,
  '--bar-button-open-color': 'white',
  '--bar-button-open-bkg': colors.grey.darken3,
  '--bar-menu-item-hover-bkg': colors.grey.darken3,
  '--bar-menu-item-disabled-color': colors.grey.base,
};

const filemenuStyleLight = {
  '--bar-button-hover-bkg': colors.grey.lighten2,
  '--bar-button-open-color': colors.grey.darken3,
  '--bar-button-open-bkg': colors.grey.lighten2,
  '--bar-menu-item-hover-bkg': colors.grey.lighten2,
};

export default defineComponent({
  name: 'Appbar',
  components: { VueFileToolbarMenu, ...components, ChangePasswordMenu },
  setup(props, ctx) {
    const { isTestServer } = useCurrentServer();
    const user = computed(() => store.state.client?.user?.username);
    const dark = computed({
      get: () => store.state.application.darkTheme,
      set: (val) => { store.commit.application.setDarkTheme(val); },
    });

    const filemenuStyle = computed(() => (dark.value ? filemenuStyleDark : filemenuStyleLight));

    const currentRoute = computed(() => ctx.root.$route);

    return {
      dark,
      filemenu,
      filemenuStyle,
      components,
      loggedIn,
      logout,
      user,
      currentRoute,
      userMenu,
      changePasswordMenu,
      mustChangePassword,
      isTestServer,
    };
  },
});
